import { STORE_ENTITIES } from '@app/constants'
import { App_User_Private } from '@app/types'

export class Set_User_Private {
  public static readonly type = `[${STORE_ENTITIES.USER_PRIVATE}] Set User Private`
  constructor(public payload: Partial<App_User_Private>) { }
}
